<template>
  <select-response-auto-complete
    :model="value"
    @update:model="$emit('update:value', $event)"
    @on-change="$emit('on-change', $event)"
    :columns="columns"
    api="RFQs/GetAllDynamic"
    :selected="selected"
    searchAllColumns
    :fields="{id: 'id', title: 'rfqid'}"
    :orderBy="{ fields: 'poDate', order: 'desc' }"
    :filters='`poIsOpen==true && po != null && po != ""`'
  />
</template>

<script>
export default {
  name: 'SelectSearchCustomerPoOpen',
  props: {
    value: {
      required: true
    }
  },
  computed: {
    columns () {
      return [
        { title: this.L10n('po-date'), value: 'poDate', type: 'date' },
        { title: this.L10n('po'), value: 'po', originField: 'po', type: 'string' },
        { title: this.L10n('rfq-type'), value: 'rfqTypeTitle', originField: 'rfqType.title', type: 'string' },
        { title: this.L10n('customer-company'), value: 'customerCompanyName', originField: 'customerCompany.name', type: 'string' },
        { title: this.L10n('customer-contact'), value: 'customerContactName', originField: 'customerContact.name', type: 'string' },
        { title: this.L10n('rfq-id'), value: 'rfqid', type: 'string', originField: 'rfqid' }
      ]
    },
    selected () {
      return [
        'id', 'rfqid', 'rfqType.title as rfqTypeTitle', 'customerCompany.name as customerCompanyName',
        'customerContact.name as customerContactName', 'po', 'poDate', 'baxEmployee.name as baxEmployeeName',
        'priority.title as priorityTitle'
      ].join(',')
    }
  }
}
</script>
